import axios from "axios";
import Swal from "sweetalert2";
import * as yup from 'yup';
import { useFormik } from "formik";
import { useEffect } from "react";
import Modal from 'react-bootstrap/Modal';

const validationSchema = yup.object({
    name: yup.string("Enter the organization name").required("Organization Name is required")
})

export const AddTeam = ({editId, setEditId, getTeams, type, show, setShow, ...rest}) => {

    const handleClose = () => setShow(false);

    const initialValues = {
        id: editId,
        name: ''
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values) =>{
        if(editId > 0){
            axios.put(`api/team`, values).then(res => {                
                setEditId(0)
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        getTeams();
                    })
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }
        else{
            axios.post(`api/team`, values).then(res => {
                setShow(false)
                if(res.data.success){
                    Swal.fire(res.data.message, '', 'success').then(result => {
                        formik.resetForm();
                        getTeams();
                    })                
                } 
                else{
                    Swal.fire(res.data.message, '', 'error')
                }
            }).catch((error) => {
                setShow(false)
                Swal.fire(error.response.data.message, '', 'error')
            });
        }        
    }

    useEffect(() => {
        if(editId > 0){
            axios.get(`api/team?id=${editId}`).then(res => {
                if(res.data.success){
                    formik.setFieldValue('id', res.data.data.id)
                    formik.setFieldValue('name', res.data.data.name)
                }
            })
        }
        else{
            formik.resetForm();
        }
        
    },[show]);

    const handlePopupClose = () => {
        formik.resetForm();
        handleClose();
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>{type} Organization</Modal.Title>
            </Modal.Header>
                <form onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label" htmlFor="basic-icon-default-name">Organization Name</label>
                                <div className="input-group input-group-merge">
                                    <span id="basic-icon-default-name" className="input-group-text"><i className="bx bx-user"></i></span>
                                    <input type="text" name="name" className="form-control" id="basic-icon-default-name" placeholder="Organization Name" aria-label="Organization Name" aria-describedby="basic-icon-default-fullname2"
                                    onChange={formik.handleChange} 
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}/>
                                </div>
                                {formik.touched.name && formik.errors.name && (<div className="text-danger">{formik.errors.name}</div>)}
                            </div>
                        </div> 
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                        <button type="submit" className="btn btn-primary">{type == 'Add' ? 'Add' : 'Update'}</button>
                    </Modal.Footer>
                </form>
        </Modal>
    )
}